import React, { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import { useAds } from "@/lib/ads";

/**
 * Reusable AdSense slot. Renders nothing when ads are disabled (no publisher ID
 * / slot configured) or for supporter/pro users. The Receipt card and share/OG
 * cards never use this.
 */
export default function AdSlot({ slot, format = "auto", layoutKey, className = "" }) {
  const { user } = useAuth();
  const { enabled, client } = useAds();
  const pushed = useRef(false);
  const show = enabled && client && slot && !(user && user.is_pro);

  useEffect(() => {
    if (!show || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      /* adsbygoogle not ready yet */
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className={`card-brutal bg-white px-3 pt-3 pb-2 relative ${className}`} data-testid="ad-slot" aria-label="Advertisement">
      <span className="absolute -top-2 left-3 text-[10px] font-mono font-bold bg-paper px-1 border-2 border-ink">AD</span>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
        {...(layoutKey ? { "data-ad-layout-key": layoutKey } : {})}
      />
    </div>
  );
}
